/**
 * @flow
 */
import React from 'react';
import baseUrl from 'utils/baseUrl';

type Props = {
  app: Object,
};

export const getShareableURL = (app: Object) => {
  const scopes = ['openid', 'profile', 'email', ...(app.userScopes || [])];
  const params = new URLSearchParams({
    client_id: app._id,
    response_type: 'code',
    scope: scopes.join(' '),
    redirect_uri: app.redirectUris?.[0] || '',
  });
  return `${baseUrl}/oidc/auth?${params.toString()}`;
};

const EmbeddableButton = ({ app }: Props) => (
  <a href={getShareableURL(app)}>
    <img
      alt="Add to Ommnio"
      height="40"
      width="160"
      src={`${baseUrl}/add_to_ommnio.png`}
      srcSet={`${baseUrl}/add_to_ommnio.png 1x, ${baseUrl}/add_to_ommnio@2x.png 2x`}
    />
  </a>
);

export default EmbeddableButton;
